export default "__VITE_ASSET__DJXbB2ay__"